import Cookies from "universal-cookie";
let setAuthorizationCookie = (token) => {
    const cookies = new Cookies();
    if (cookies.get("old-admin")){
        cookies.remove("old-admin", {
            path: "/",
            domain: ".programmingpathshala.com",
        });
        //uncomment to run locally
        //cookies.remove("old-admin");
    }

    // cleanup of the legacy "authorization" cookie
    if (cookies.get("authorization")){
        cookies.remove("authorization", {
            path: "/",
            domain: "admin.programmingpathshala.com",
        });
        cookies.remove("authorization", {
            path: "/",
            domain: ".programmingpathshala.com",
        });
    }

    cookies.set("old-admin", token, {
        path: "/",
        domain: ".programmingpathshala.com",
    });

    //uncomment to run locally
    //cookies.set("old-admin", token);
};

export { setAuthorizationCookie };
